import React, { forwardRef, useImperativeHandle, useState } from 'react';
import '../App.css';
import cross from '../assets/cross.png';
import cross_screen from '../assets/cross_screen.png';
import { getScreenshotList, getScreenshotImge } from '../model/util';

let from='', tokenFromAzureLoginBackUp='',base64OfSelectedImage='';
const DisplayParticipantComponent = forwardRef(({ CbFromParticipant }, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isRecordingModal, setIsRecordingModal] = useState(false);
  const [displayScreenShotArr, setDisplayScreenShotArr] = useState([]);
  const [dynamicMessage, setDynamicMessage] = useState('');
  const [selectedBase64, setSelectedBase64] = useState('');
 
  useImperativeHandle(ref, () => ({
    open: (fromAppJs='screenShot') => {
      from=fromAppJs;
      CbFromParticipant({isOpen:true, from:'screenShot'})
      setIsVisible(true);
    },
    update: ({ progressId, tokenFromAzureLogin}) => {
      tokenFromAzureLoginBackUp=tokenFromAzureLogin
      getScreenshotList({ progressId, tokenFromAzureLogin }).then(data=>{
        console.log('------get screen shot list before update----',data)
        setDisplayScreenShotArr(data && data.listData ? data.listData:[]);
      })
    },
    close: () => {
      CbFromParticipant({isOpen:false, from:'participant'})
      setIsVisible(false);
    },
    updateDynamicMsg: (msg) => {
      setDynamicMessage(msg)
    }
  }));

  if (!isVisible) return null;

  return (
    <div className='participant-panel'>
      <div className='panel-header'>
        <div className='header-style'>Screen Shot</div>
        <img src={cross} className='crss-img' onClick={() => { 
          CbFromParticipant({isOpen:false, from:'screenShot'})
          setIsVisible(false) 
        }} />
      </div>
      <div className='lobby-div-screenshot'>
        
        {displayScreenShotArr.map((item, index) => (
          <div  className='scrn-shot' onClick={()=>{
            getScreenshotImge({tokenFromAzureLoginBackUp,item }).then(data=>{
              base64OfSelectedImage=data?.documentencdata;
              setSelectedBase64(data?.documentencdata)
              setIsRecordingModal(true)
              console.log(base64OfSelectedImage,'------data123----',data)
            })
          }}>
           {/* <div className='scrsh-text'>{item.filename_gen}</div> */}
           <div className='scrsh-text'>Image {index+1}</div>
          </div>

        ))}
      </div>
      {isRecordingModal ?
        <div className="dialog-overlay-screenshot" onClick={() => {
          setIsRecordingModal(false)
          }}>
          <div className='crss-pos'>
            <img src={cross_screen} className='crss_1-img' />
            <img src={`data:image/jpeg;base64,` + selectedBase64} className='image_screenshot' />
          </div>
          
          
        </div> : null}
    </div>
  );
});

export default DisplayParticipantComponent;
